import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Table } from 'react-bootstrap';
import { list_ies, delete_ie } from '../../../utils/ies_services';
import { loadCountriesData, buildCountryIndex } from '../../../utils/countries';
import './Instituciones.css';

function Instituciones({ permission }) {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const canWrite = parseInt(permission, 10) === 1;
  const [rows, setRows] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [countryIndex, setCountryIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const resolveCountryLabel = (countryCode) => {
    if (!countryCode) return '—';
    const upper = String(countryCode).trim().toUpperCase();
    if (countryIndex?.byCca3?.[upper]) {
      return countryIndex.byCca3[upper].name;
    }
    return countryCode;
  };

  const loadList = async () => {
    setIsLoading(true);
    const response = await list_ies(token);
    if (response === 'INVALID') {
      navigate('/');
      return;
    }
    setRows(Array.isArray(response) ? response : []);
    setIsLoading(false);
  };

  useEffect(() => {
    if (token) {
      loadList();
    }
    loadCountriesData()
      .then((data) => setCountryIndex(buildCountryIndex(data)))
      .catch((error) => console.error('Error cargando países:', error));
  }, [token]);

  const filteredRows = useMemo(() => {
    const q = filterText.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((row) => {
      const name = String(row.name || '').toLowerCase();
      const city = String(row.city || '').toLowerCase();
      const country = resolveCountryLabel(row.country).toLowerCase();
      const departamento = String(row.departamento || '').toLowerCase();
      const zona = String(row.zona || '').toLowerCase();
      const sede = String(row.sede || '').toLowerCase();
      return (
        name.includes(q) ||
        city.includes(q) ||
        country.includes(q) ||
        departamento.includes(q) ||
        zona.includes(q) ||
        sede.includes(q)
      );
    });
  }, [rows, filterText, countryIndex]);

  const handleDelete = async (event, ieId) => {
    event.stopPropagation();
    if (!canWrite) return;
    const confirmed = window.confirm('¿Seguro que quieres eliminar esta institución?');
    if (!confirmed) return;

    const response = await delete_ie(token, ieId);
    if (response === 'INVALID') {
      navigate('/');
      return;
    }
    if (response?.ok) {
      await loadList();
    } else {
      window.alert(response?.error || 'No se pudo eliminar.');
    }
  };

  return (
    <div className="container-fluid py-4 instituciones-page">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Instituciones</h2>
        <Form.Control
          type="search"
          className="instituciones-search"
          placeholder="Buscar por nombre, país, ciudad, departamento…"
          value={filterText}
          onChange={(event) => setFilterText(event.target.value)}
        />
      </div>

      <Table hover responsive className="align-middle instituciones-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>País</th>
            <th>Ciudad</th>
            <th>Departamento</th>
            <th>Zona</th>
            <th>Sede</th>
            {canWrite && <th style={{ width: '7rem' }} />}
          </tr>
        </thead>
        <tbody>
          {filteredRows.map((row) => (
            <tr
              key={row.id}
              onClick={() => navigate(`/institucion_panel?id=${row.id}`)}
              className="instituciones-row"
            >
              <td>{row.name}</td>
              <td>{resolveCountryLabel(row.country)}</td>
              <td>{row.city}</td>
              <td>{row.departamento || '—'}</td>
              <td>{row.zona || '—'}</td>
              <td>{row.sede || '—'}</td>
              {canWrite && (
                <td className="text-end">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={(event) => handleDelete(event, row.id)}
                  >
                    Eliminar
                  </Button>
                </td>
              )}
            </tr>
          ))}
          {!isLoading && filteredRows.length === 0 && (
            <tr>
              <td colSpan={canWrite ? 7 : 6} className="text-center py-4 text-muted">
                No hay instituciones
              </td>
            </tr>
          )}
          {isLoading && (
            <tr>
              <td colSpan={canWrite ? 7 : 6} className="text-center py-4 text-muted">
                Cargando…
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {canWrite && (
        <Button
          variant="primary"
          className="floating-add-button"
          onClick={() => navigate('/institucion_panel')}
          aria-label="Agregar institución"
        >
          +
        </Button>
      )}
    </div>
  );
}

export default Instituciones;
